<template>
  <div>
    <footer class="ecommerce-footer">
        <div class="container">
            <div class="row footer-theme partition-f">
                <div class="col-lg-3 col-md-12" style="margin:auto">
                    <div class="footer-title footer-mobile-title">
                        <h4>about</h4>
                    </div>
                    <div class="footer-contant" style="text-align:center">
                        <div class="footer-logo" style="margin-bottom:18px;"><img style="max-width:55px" alt="" src="../../theme-assets/images/logo/culogo-h.png"></div>
                        <h4 style="color:#e43150;margin-bottom:0px;">University Of Chittagong</h4>
                        <div class="footer-social">
                            <ul>
                                <li><a href="https://www.facebook.com/ictcu"><i aria-hidden="true" class="fa fa-facebook"></i></a></li>
                                <!-- <li><a href="#"><i aria-hidden="true" class="fa fa-google-plus"></i></a></li> -->
                                <!-- <li><a href="https://twitter.com/UChittagong"><i aria-hidden="true" class="fa fa-twitter"></i></a></li> -->
                                <li><a href="https://www.youtube.com/channel/UClQg__wc5h3uW_YHSD-iMbg"><i aria-hidden="true" class="fa fa-youtube"></i></a></li>
                                <!-- <li><a href="#"><i aria-hidden="true" class="fa fa-rss"></i></a></li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-12">
                     <div class="sub-title">
                        <div class="footer-title">
                            <h4>Contact Information</h4>
                        </div>
                        <div class="footer-contant">
                        <table style="font-weight: boldx;">
                            <tr>
                                <th class="count-desc text-white">Unit</th>
                                <th class="count-desc text-white">&nbsp;</th>
                                <th class="count-desc text-white">Phone Number</th>
                            </tr>
                            <tr>
                                <td style="vertical-align: baseline;" class="count-desc text-white">A</td>
                                <td class="count-desc text-white">&nbsp;</td>
                                <td class="count-desc text-white">
                                    01555555135 (Faculty of Science),<br>
                                    01555555142 (Faculty of Biological Sciences),<br>
                                    01555555156 (Faculty of Engineering),<br>
                                    01555555157 (Faculty of Marine Sciences and Fisheries)
                                </td>
                            </tr>
                            <tr>
                                <td style="vertical-align: baseline;" class="count-desc text-white">B/B1/B2</td>
                                <td class="count-desc text-white">&nbsp;</td>
                                <td class="count-desc text-white">
                                    01555555136 (Faculty of Arts and Humanities)
                                </td>
                            </tr>
                            <tr>
                                <td style="vertical-align: baseline;" class="count-desc text-white">C</td>
                                <td class="count-desc text-white">&nbsp;</td>
                                <td class="count-desc text-white">
                                    01555555137 (Faculty of Business Administration)
                                </td>
                            </tr>
                            <tr>
                                <td style="vertical-align: baseline;" class="count-desc text-white">D/D1</td>
                                <td class="count-desc text-white">&nbsp;</td>
                                <td class="count-desc text-white">
                                    01555555138 (Faculty of Social Sciences),<br>
                                    01555555139 (Faculty of Law),<br>
                                    01555555142 (Faculty of Biological Sciences)
                                </td>
                            </tr>
                        </table>
                            <!--<ul class="contact-list">
                                <li><i class="fa fa-clock-o"></i>Working Hour: 9.00AM - 5.00PM</li>
                                <li><i class="fa fa-mobile"></i>Helpdesk: 01555555140, 01555555141</li>
                                <li>Technical: 01556570077</li>
                                <li><i class="fa fa-fax"></i>PABX: 2606001-10, 2606015-27, Extn. 4259</li>
                                <li><i class="fa fa-map-marker"></i>ICT Cell, IT Building, University of Chittagong</li>
                            </ul>-->
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-12">
                    <div class="sub-title">
                        <div class="footer-title">
                            <h4>Admission Hotline</h4>
                        </div>
                        <div class="footer-contant">
                            <table style="font-weight: boldx;">
                                <!-- <tr><td class="count-desc text-white">Secretary, Admission Test</td></tr>
                                <tr><td class="count-desc text-white">017884997331</td></tr> -->
                                <tr><th class="count-desc text-white">ICT Cell Help Desk</th></tr>
                                <tr><td class="count-desc text-white">01555555140, 01555555141, 01556570077</td></tr>
                                <tr><td class="count-desc text-white"><b>Email:</b> admission@cu.ac.bd</td></tr>
                                <tr><td class="count-desc text-white"><b>Working Hour:</b> 9.00AM - 7.00PM</td></tr>
                                <tr><td class="count-desc text-white"><b>Location:</b> ICT Cell, IT Building, University of Chittagong</td></tr>
                                <tr><td class="count-desc text-white"><b>Official SMS:</b> 01708404777, 01841644355</td></tr>
                            </table>
                            <!--<ul class="contact-list">

                                <li><i class="fa fa-phone"></i>Secretary, Admission Test:017884997331
                                 
                                 </li>
                                
                                <li>ICT Cell Help Desk: 01555555140, 01555555141, 01556570077</li>
                                
                                <li>Official SMS: 01708404777, 01841644355</li>
                                <li><i class="fa fa-envelope-o"></i>Email Us: admission@cu.ac.bd</li>
                            </ul>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-footer">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 col-md-12 col-sm-12">
                        <div class="footer-end">
                            <p><i aria-hidden="true" class="fa fa-copyright"></i> University of Chittagong. All Rights Reserved | Powered by: ICT Cell</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- <footer class="footer" hidden>
      <center>Copyright &copy; {{ new Date().getFullYear() }}</center>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style>
.footer {
  width: 100%;
  height: 50px;
  background-color: teal;
  color: white;
  padding: 10px;
  font-size: 1.5em;
}
</style>
